import type { SegmentDefinitionSummary } from '../../edit-automation-template/segment-definitions-api';
import { StatusFilter } from '../../automations-tab/templates-manager/types';

/**
 * Segments only have two derived tiers (no "Available" — they have no on/off per tenant):
 * - `Draft`: synced to no one (`targetedTenantsFilter === []`)
 * - `Active`: synced to ≥1 tenant (all, or a specific set)
 */
export type SegmentListStatus = StatusFilter.Draft | StatusFilter.Active;

/** Draft keys off the raw filter being an empty array, never a resolved-count of 0. */
export function isDraftFilter(targetedTenantsFilter: string[] | null | undefined): boolean {
  return Array.isArray(targetedTenantsFilter) && targetedTenantsFilter.length === 0;
}

export function deriveSegmentStatus(segment: SegmentDefinitionSummary): SegmentListStatus {
  return isDraftFilter(segment.targetedTenantsFilter) ? StatusFilter.Draft : StatusFilter.Active;
}

/** Business IDs a segment is synced to: null = all current tenants, [] = none, else the filter. */
export function resolveSyncedBusinessIds(
  segment: SegmentDefinitionSummary,
  rosterBusinessIds: string[],
): string[] {
  const filter = segment.targetedTenantsFilter;
  if (filter === null || filter === undefined) {
    return rosterBusinessIds;
  }
  if (filter.length === 0) {
    return [];
  }
  const rosterSet = new Set(rosterBusinessIds);
  return filter.filter(id => rosterSet.has(id));
}

/** Turn a hyphenated segment slug into a display name ("repeat-customers" → "Repeat Customers"). */
export function formatSegmentName(name: string): string {
  return name
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
